import firebase from 'firebase';
import moment from 'moment';
let db = firebase.database();

export async function FetchModernSlug(coachOrgId) {
  //For redirecting to to my.trybe.fit
  try {
    const path = `internal/coachOrgSlugs/${coachOrgId}`;
    const result = await db.ref(path).once('value').then(s => s.val());
    return result;
  } catch(e) {
    throw e;
  }
}

export function FetchProductInfo(action) {
  return new Promise(async (resolve, reject) => {
    try {
      const { coachOrgId } = action;
      const path = `coachOrgs/${coachOrgId}/productInfo`;
      const result = await db.ref(path).once('value').then(s => s.val());
      resolve(result);
    } catch(e) {
      reject(e);
    }
  });
}

export function FetchCoachOrgLogo(coachOrgId) {
  return new Promise(async (resolve, reject) => {
    try {
      const path = `coachOrgs/${coachOrgId}/productInfo/logo`;
      const result = await db.ref(path).once('value').then(s => s.val());
      resolve(result);
    } catch(e) {
      reject(e);
    }
  });
}

export function FetchOnboardingOptions(action) {
  return new Promise(async (resolve, reject) => {
    try {
      const { coachOrgId } = action;
      const path = `coachOrgs/${coachOrgId}/onboardingGoalOptions`;
      const result = await db.ref(path).once('value').then(s => s.val());
      resolve(result);
    } catch(e) {
      reject(e);
    }
  });
}

export function StripePassCredentials(authCode, scope) {
  return new Promise((resolve, reject) => {
    try {
      const writeRef = db.ref('requests/stripe/grantConnectAccess').push();

      const data = {
        id: writeRef.key,
        authCode,
        scope
      }

      writeRef.set(data);

    } catch(e) {
      console.log('StripePassCredentials error', e);
      reject(e);
    }
  });
}

export function InitUpdateCard(action) {
  return new Promise(async (resolve, reject) => {
    try {
      const { uid, stripeData } = action;
      const path = `requests/onUpdateCard/${uid}/stripeData`;
      db.ref(path).set(stripeData);
      resolve(path);
    } catch(e) {
      reject(e);
    }
  });
}

export function ListenUserUpdateCardResponse(path, dispatch){
  db.ref(path).on('value', snap => {
    const val = snap.val();
    if(!val){
      return;
    }

    if(val.err){
      dispatch({
        type: 'SET_UPDATE_CARD_RESULT',
        err: true
      });
    } else if(val.success){
      dispatch({
        type: 'SET_UPDATE_CARD_RESULT',
        success: true
      });
    }

    db.ref(path).off();
  })
}

export const InitStripeCheckout = (data) => {
  return new Promise(async (resolve, reject) => {
    const {
      planSelected,
      coachOrgStripePubKey,
      coachOrgId,
      successURL,
      userId, //optional, not needed if mobileRequestId present
      firstname, //optional, not needed if mobileRequestId present
      lastname, //optional, not needed if mobileRequestId present
      email, //optional, not needed if mobileRequestId present
      stripeCouponId, //optional
      mobileRequestId, //optional, not needed if user created acct or logged in
      requireBillingAddress, //optional
      ap, //optional,
      discountedPrice, //optional
      rewardfulId, //optional
      isGiftPurchase,//optional
      giftEmail,//optional
      productName,//optional
      coachLogo,//optional
      sendGiftAt,//optional
      userConfirmedWaiveTrial, //optional
    } = data;

    const uid = db.ref(`requests/initStripeCheckout/${coachOrgId}`).push().key;
    const path = `requests/initStripeCheckout/${coachOrgId}/${uid}`
    const listenerPath = `${path}/response`;

    db.ref(listenerPath).on('value', snap => {
      onListenerResponse(snap.val(), listenerPath, resolve, reject);
    }, err => {
      console.log('listener err', err)
    })

    db.ref(path).set({
      uid,
      planSelected,
      coachOrgStripePubKey,
      coachOrgId,
      successURL,
      createdAt: moment().valueOf(),
      dateFormatted: moment().format('dddd, MMM Do YYYY, ha'),
      source: 'site',
      userId: userId || null,
      firstname: firstname || null,
      lastname: lastname || null,
      email: email || null,
      stripeCouponId: stripeCouponId || null,
      mobileRequestId: mobileRequestId || null,
      requireBillingAddress: requireBillingAddress || null,
      ap: ap || null,
      discountedPrice: discountedPrice || null,
      rewardfulId: rewardfulId || null, //Ultimately passed to Stripe as client_reference_id
      isGiftPurchase: isGiftPurchase || null,
      giftEmail: giftEmail || null,
      productName: productName || null,
      coachLogo: coachLogo || null,
      sendGiftAt: sendGiftAt || null,
      userConfirmedWaiveTrial: userConfirmedWaiveTrial || null
    });
  });
}

export const InitRedeemVoucher = (data) => {
  return new Promise(async (resolve, reject) => {
    const {
      voucherId,
      userId,
    } = data;

    const uid = db.ref(`requests/redeemVoucher`).push().key;
    const path = `requests/redeemVoucher/${uid}`
    const listenerPath = `${path}/response`;

    db.ref(listenerPath).on('value', snap => {
      onListenerResponse(snap.val(), listenerPath, resolve, reject);
    }, err => {
      console.log('listener err', err)
    })

    db.ref(path).set({
      uid,
      voucherId,
      userId,
      createdAt: moment().valueOf(),
      dateFormatted: moment().format('dddd, MMM Do YYYY, ha'),
    });
  });
}

const onListenerResponse = (response, listenerPath, resolve, reject) => {
  if (!response) return;

  if (response.success) {
    db.ref(listenerPath).off();
    resolve({
      success: response.success,
      error: null
    });
  } else if (response.error) {
    db.ref(listenerPath).off();
    resolve({
      success: null,
      error: response.error
    });
    reject(response.error);
  }
}

export function InitLegacyStripeCheckout(data) {
  return new Promise(async (resolve, reject) => {
    try {
      if(data.uid){
        //request started from mobile, so some data at uid path is prepopulated
        const { coachOrgId, uid, stripeData } = data;
        const listenerPath = `requests/legacyCheckoutSub/${coachOrgId}/${uid}/response`;
        const writePath = `requests/legacyCheckoutSub/${coachOrgId}/${uid}/stripeData`;

        //listen for success or err; if one is sent, resolve
        db.ref(listenerPath).on('value', snap => {
          onListenerResponse(snap.val(), listenerPath, resolve, reject);
        }, err => {
          console.log('InitLegacyStripeCheckout err', err)
        })

        db.ref(writePath).set(stripeData);
      } else {
        //if is new user who never initiated payment from site,
        //create new uid and save data that's needed

        const {
          userId,
          email,
          firstname,
          lastname,
          stripeData,
          coachOrgId,
        } = data;

        const pushRef = db.ref('requests/stripe/grantConnectAccess').push();
        const uid = pushRef.key;
        console.log('new uid is', uid);
        const listenerPath = `requests/legacyCheckoutSub/${coachOrgId}/${uid}/response`;
        const writePath = `requests/legacyCheckoutSub/${coachOrgId}/${uid}`;

        //listen for success or err; if one is sent, resolve
        db.ref(listenerPath).on('value', snap => {
          onListenerResponse(snap.val(), listenerPath, resolve, reject);
        }, err => {
          console.log('InitLegacyStripeCheckout err', err)
        })

        db.ref(writePath).set({
          userId,
          email,
          firstname,
          lastname,
          stripeData,
          coachOrgId,
        });
      }
    } catch(e) {
      reject(e);
    }
  });
}


// WEBPACK FOOTER //
// ./src/api/payment.api.js